var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareFacebook = function SvgShareFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "shareFacebook_svg__sc-gKsewC shareFacebook_svg__fzJjte",
    "data-testid": "ShareIcon-facebook",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#1877F2",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18 12a6 6 0 1 0-12 0 6 6 0 0 0 5.063 5.928v-4.193H9.539V12h1.524v-1.322c0-1.503.895-2.334 2.266-2.334.656 0 1.343.117 1.343.117v1.477h-.757c-.745 0-.977.463-.977.937V12h1.664l-.267 1.735h-1.398v4.193A6 6 0 0 0 18 12"
  })));
};
export default SvgShareFacebook;